module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": true,
      "persistent": "",
      "max-width": "350"
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.$appData.login_selected_tab),
      callback: function($$v) {
        _vm.$set(_vm.$appData, "login_selected_tab", $$v)
      },
      expression: "$appData.login_selected_tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "blue lighten-1"
  }, [_c('v-tabs-item', {
    attrs: {
      "href": '#login',
      "ripple": ""
    }
  }, [_vm._v("\n        Anmelden\n      ")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": '#register',
      "ripple": ""
    }
  }, [_vm._v("\n        Registrieren\n      ")]), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "indigo darken-2"
    }
  })], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": 'login'
    }
  }, [_c('v-card', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-form', {
    attrs: {
      "action": "login",
      "submitButtonText": "Login"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Benutzername oder E-Mail-Adresse",
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.username),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "username", $$v)
      },
      expression: "$appData.account.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Passwort",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e1 = !_vm.e1); },
      "type": _vm.e1 ? 'password' : 'text',
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.password),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "password", $$v)
      },
      expression: "$appData.account.password"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2"
  }, [_c('small', [_vm._v("* Eingabe erforderlich")])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": 'register'
    }
  }, [_c('v-card', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-form', {
    attrs: {
      "action": "login",
      "submitButtonText": "Login"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "gewünschter Benutzername",
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.username),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "username", $$v)
      },
      expression: "$appData.account.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "E-Mail-Adresse",
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.email),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "email", $$v)
      },
      expression: "$appData.account.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "gewünschtes Passwort",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e1 = !_vm.e1); },
      "type": _vm.e1 ? 'password' : 'text',
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.password),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "password", $$v)
      },
      expression: "$appData.account.password"
    }
  }), _vm._v("\n              Damit wir den Zugang zuordnen können, geben Sie bitte folgende Informationen an:\n              "), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.$appData.account.name),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "name", $$v)
      },
      expression: "$appData.account.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Telefon"
    },
    model: {
      value: (_vm.$appData.account.phone),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "phone", $$v)
      },
      expression: "$appData.account.phone"
    }
  }), _vm._v("\n              Wenn Sie möchten, können Sie die folgenden Felder ausfüllen. Sollten die Daten mit unserem System übereinstimmen, wird Ihr Zugang automatisch freigeschaltet.\n              "), _c('v-text-field', {
    attrs: {
      "label": "Kundennummer"
    },
    model: {
      value: (_vm.$appData.account.customer_nr),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "customer_nr", $$v)
      },
      expression: "$appData.account.customer_nr"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Rechnungsnummer"
    },
    model: {
      value: (_vm.$appData.account.invoice_nr),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "invoice_nr", $$v)
      },
      expression: "$appData.account.invoice_nr"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Rechnungsdatum"
    },
    on: {
      "blur": function($event) {
        _vm.date = _vm.parseDate(_vm.$appData.account.invoice_date)
      }
    },
    slot: "activator",
    model: {
      value: (_vm.$appData.account.invoice_date),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "invoice_date", $$v)
      },
      expression: "$appData.account.invoice_date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "de-DE",
      "no-title": "",
      "scrollable": "",
      "actions": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        _vm.$appData.account.invoice_date = _vm.formatDate($event)
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Rechnungsbetrag"
    },
    model: {
      value: (_vm.$appData.account.invoice_total),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "invoice_total", $$v)
      },
      expression: "$appData.account.invoice_total"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2"
  }, [_c('small', [_vm._v("* Eingabe erforderlich")])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("Jetzt registrieren")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4f58332","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Login.vue
// module id = 589
// module chunks = 1